// app.guide._index.tsx — "How Quote Desk works" in-app help/guide page.
export const guide = {
  heading: "How Quote Desk works",
  intro: "Quote Desk turns B2B price negotiations into Shopify draft orders in three steps. Here's the whole flow, plus answers to common questions.",
  createFirstQuote: "Create your first quote",
  threeStepFlowHeading: "The three-step flow",
  steps: {
    createQuoteTitle: "Create a quote",
    createQuoteBody:
      "Pick a B2B company and contact, add products with custom per-line pricing, and save. Quote Desk handles currency, discounts, and tax for you.",
    buyerAcceptsTitle: "Buyer reviews & accepts",
    buyerAcceptsBody:
      "Send the quote and your buyer gets a secure email link to view it. They accept or decline right from the link — no account, no friction.",
    draftOrderTitle: "Draft order appears",
    draftOrderBody:
      "On accept, Quote Desk auto-creates a Shopify B2B draft order with the negotiated prices and the right purchasing entity — ready to convert.",
  },
  whatYouCanDoHeading: "What you can do",
  features: {
    customPricingTitle: "Custom per-line pricing",
    customPricingBody: "Set any price on any line. Subtotal, discounts, and tax recalculate automatically as you build.",
    secureLinksTitle: "Secure buyer links",
    secureLinksBody: "Every quote link is signed and scoped to a single quote, with optional expiry — safe to email directly.",
    poParsingTitle: "PO upload & parsing",
    poParsingBody:
      "Upload a customer purchase order (PDF) and Quote Desk extracts the line items with AI to draft a quote in seconds.",
    aiCounterOffersTitle: "AI counter-offers",
    aiCounterOffersBody:
      "Generate a smart counter-offer informed by the company's order history when a buyer pushes back on price.",
    bulkImportTitle: "Bulk import & export",
    bulkImportBody: "Import quotes from CSV and export any filtered list back out — handy for migrations and reporting.",
    followUpTitle: "Follow-up nudges",
    followUpBody:
      "Your dashboard surfaces quotes that have gone quiet (unviewed or undecided) so no deal stalls silently.",
  },
  faqHeading: "Frequently asked questions",
  faq: {
    plusQ: "Do I need Shopify Plus?",
    plusA: "No. Quote Desk works on every plan that supports B2B companies — not just Plus.",
    accountQ: "Does the buyer need an account?",
    accountA: "No. Buyers act on a secure emailed link; there's no login or signup for them.",
    acceptQ: "What happens when a buyer accepts?",
    acceptA: "We record the acceptance and automatically create a Shopify B2B draft order with the negotiated prices.",
    reviseQ: "Can I revise a quote after sending?",
    reviseA: "Use Duplicate to start a revised quote, or send a counter-offer. Sent quotes stay locked for a clean audit trail.",
    whereQ: "Where do my quotes live?",
    whereA: "All quotes are listed under Quotes in the nav, where you can filter, export, and open any one for full detail.",
  },
};
